import { ProfileMenu } from '@here/hds-navbar';
import React, { useEffect, useImperativeHandle } from 'react';
// eslint-disable-next-line no-new
new ProfileMenu();
const HDSProfileMenu = React.forwardRef(({ profileName, profileEmail, avatarImageUrl, open, noTrigger, signup, onChange, children, className, ...rest }, ref) => {
    const innerRef = React.useRef(null);
    useImperativeHandle(ref, () => innerRef.current);
    const _handleChange = (e) => {
        if (e.target !== innerRef.current)
            return;
        onChange && onChange(e.detail);
    };
    useEffect(() => {
        if (onChange && innerRef.current) {
            innerRef.current.addEventListener('change', _handleChange);
        }
        return () => innerRef.current?.removeEventListener('change', _handleChange);
    }, [onChange, innerRef]);
    return (React.createElement("hds-profile-menu", { ...(profileName && { 'profile-name': profileName }), ...(profileEmail && { 'profile-email': profileEmail }), ...(avatarImageUrl && { 'avatar-image-url': avatarImageUrl }), ...(open && { open }), ...(signup && { signup }), ...(noTrigger && { 'no-trigger': noTrigger }), ...(className && { class: className }), ref: innerRef, ...rest }, children));
});
HDSProfileMenu.defaultProps = {
    profileName: '',
    profileEmail: '',
    open: false,
    signup: false,
    noTrigger: false,
    avatarImageUrl: '',
};
export default HDSProfileMenu;
//# sourceMappingURL=HDSProfileMenu.js.map